var map = {
	"./CanvasClear": 47,
	"./CanvasClear.js": 47,
	"./CanvasMove": 48,
	"./CanvasMove.js": 48,
	"./CommandAbstract": 23,
	"./CommandAbstract.js": 23,
	"./ComponentDelete": 49,
	"./ComponentDelete.js": 49,
	"./ComponentDrag": 50,
	"./ComponentDrag.js": 50,
	"./ComponentEnter": 51,
	"./ComponentEnter.js": 51,
	"./ComponentExit": 52,
	"./ComponentExit.js": 52,
	"./ComponentNext": 53,
	"./ComponentNext.js": 53,
	"./ComponentPrev": 54,
	"./ComponentPrev.js": 54,
	"./ComponentStyleClear": 55,
	"./ComponentStyleClear.js": 55,
	"./CopyComponent": 56,
	"./CopyComponent.js": 56,
	"./DeleteComponent": 57,
	"./DeleteComponent.js": 57,
	"./ExportTemplate": 58,
	"./ExportTemplate.js": 58,
	"./Fullscreen": 59,
	"./Fullscreen.js": 59,
	"./MoveComponent": 60,
	"./MoveComponent.js": 60,
	"./OpenAssets": 61,
	"./OpenAssets.js": 61,
	"./OpenBlocks": 62,
	"./OpenBlocks.js": 62,
	"./OpenLayers": 63,
	"./OpenLayers.js": 63,
	"./OpenStyleManager": 64,
	"./OpenStyleManager.js": 64,
	"./OpenTraitManager": 65,
	"./OpenTraitManager.js": 65,
	"./PasteComponent": 66,
	"./PasteComponent.js": 66,
	"./Preview": 67,
	"./Preview.js": 67,
	"./Resize": 68,
	"./Resize.js": 68,
	"./SelectComponent": 16,
	"./SelectComponent.js": 16,
	"./SelectPosition": 29,
	"./SelectPosition.js": 29,
	"./ShowOffset": 69,
	"./ShowOffset.js": 69,
	"./SwitchVisibility": 70,
	"./SwitchVisibility.js": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;